import type { FC } from "react";
import React, { useMemo } from "react";

import { HEADER_CLOSE_TEST_ID } from "./utils/createTestId";
import { extractProps, getChildrenRecord } from "../../../utils/react";
import { CoreHeader } from "../general/CoreHeader/CoreHeader";

import type { HeaderProps } from "../general/CoreHeader/types";

export const HEADER_CLOSE_DISPLAY_NAME = "HeaderClose";

/**
 * Компонент для отображения и разметки заголовков, основан на CoreHeader.
 *
 * Умеет отображать заголовки нескольких уровней, в качестве rightAddon предустановлен buttonCircle с иконкой-крестиком "Закрыть".
 *
 * <a href="https://www.figma.com/design/vTg3KAvmAXA9LigeyiqCWL/%F0%9F%92%A0-Base-Components?node-id=7340-489867&m=dev" target="_blank">Спека</a>
 * @constructor
 */
export const HeaderClose: FC<HeaderProps> = (props) => {
    const {
        customVarsStyles,
        currentProps: {
            view = "primary",
            children,
            "data-tsid": tsid = HEADER_CLOSE_TEST_ID,
            ...restProps
        },
    } = useMemo(() => extractProps(props, ["customVarsStyles"]), [props]);

    const content = useMemo(
        () =>
            getChildrenRecord(
                children,
                HEADER_CLOSE_DISPLAY_NAME,
                {
                    Title: {
                        props: { view },
                        required: true,
                    },
                    CounterInline: {
                        props: { view },
                    },
                    Subtitle: {
                        props: { view },
                    },
                    RightButtonCircle: {
                        props: { view },
                    },
                    Unknown: {
                        skipElement: true,
                    },
                },
                { isArrayResult: true },
            ),
        [children, view],
    );

    return (
        <CoreHeader
            {...restProps}
            customVarsStyles={customVarsStyles}
            data-tsid={tsid}
            data-uikit={HEADER_CLOSE_DISPLAY_NAME}
            view={view}
            prefix="HeaderClose"
        >
            {content}
        </CoreHeader>
    );
};

HeaderClose.displayName = HEADER_CLOSE_DISPLAY_NAME;

export default HeaderClose;
